import { gql } from '@apollo/client';

export * from './createFeedback.mutation.generated';

export const CREATE_FEEDBACK = gql`
  mutation createFeedback($message: String!) {
    createFeedback(input: { message: $message }) {
      success
      errors
    }
  }
`;
